/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import DOMPurify from "dompurify";
import { useDispatch, useSelector } from "react-redux";
import { getSettingApi } from "../../../Features/Setting/Setting";
import PolicyLayout from "./PolicyLayout";

function Faq() {
  const dispatch = useDispatch();
  const setting = useSelector((s) => s.setting?.settingData);

  useEffect(() => {
    dispatch(getSettingApi());
    window.scrollTo(0, 0);
  }, []);

  return (
    <PolicyLayout
      breadcrumb="FAQ"
      eyebrow="Help & Support"
      title="Frequently Asked Questions"
      intro="Answers to the questions our customers ask most often. Can't find what you're looking for? Our team is one click away."
      htmlBlocks={[DOMPurify.sanitize(setting?.app_faq || "")]}
      fallback="Our FAQ is being prepared. In the meantime, send any question through the contact form and we'll come back to you within one working day."
      contactCtaText="Still have a question? Our team typically reply within one working day."
    />
  );
}

export default Faq;
